// CreativeCommons Shopify scripts 
// console callback for unsupporting browsers.
if (typeof (console) === 'undefined') {
  var console = {};
  console.log = console.error = console.info = console.debug = console.warn = console.trace = console.dir = console.dirxml = console.group = console.groupEnd = console.time = console.timeEnd = console.assert = console.profile = function () {};
}

// Change Cart's Total after add or edit item
Ajax.Responders.register({
  onComplete: function (request) {
    "use strict";
    
    if (window.onbeforeunload !== null) {
   	  window.onbeforeunload = null;
    }

    if (request.method === 'post' && request.url === '/cart/change.js') {
      Shopify.getCart(function (data) {
        $('cart-total-price').innerHTML = Shopify.formatMoney(data.total_price);
      });
    }
  }
});

var CCShopify = {};

// Toggles the visibility of a variant description.
CCShopify.toggleVariantDescription = function (el) {
  var p = $(el).up();
  if ($(p).getStyle('height') == '54px') {
    el.innerHTML = '[-]';

    $(p).setStyle({
      'height': 'auto'
    });
  } else {
    el.innerHTML = '[+]';

    $(p).setStyle({
      'height': '54px'
    });
  }
};

CCShopify.toggleProductDescription = function (el) {
  // calculate the required height.  
  try {
    foundinHeight = $(el).up().up().up().down('.found-in').getHeight();
  } catch (e) {
    foundinHeight = 0;
  }
  console.log('foundinHeight = ' + foundinHeight);
  var reqHeight = 102 - $(el).up().up().down('h3').getHeight() - foundinHeight;
  var p = $(el).up();
  if ($(p).getStyle('height') == reqHeight + 'px') {
    el.innerHTML = '[-]';
    $(p).setStyle({
      'height': 'auto'
    });
  } else {
    el.innerHTML = '[+]';
    $(p).setStyle({
      'height': reqHeight + 'px'
    });
  }
};

CCShopify.enableProductDescriptionToggles = function () {
  $$('.product-details .product-description').each(function (x) {
    var prid = x.up('.product-row').id;
    if (prid == "mixed-box-of-the-week-50" || prid == "a-bonus-for-the-week-hidden" || prid == "cooler-bags-ice-packs") return;
    x.setStyle({
      'height': 'auto'
    });
    try {
      foundinHeight = x.up().up().up().down('.found-in').getHeight();
    } catch (e) {
      foundinHeight = 0;
    }
    var reqHeight = 102 - x.up().up().down('h3').getHeight() - foundinHeight;
    if (x.getHeight() > reqHeight) {
      x.setStyle({
        'height': reqHeight + 'px'
      });
      x.down('.product-description-toggle').setStyle({
        'display': 'block'
      });
    }
  });
};

// Get the variant descriptions, add a toggle visibility button if it's more than one line.
CCShopify.enableVariantDescriptionToggles = function () {
  $$('.variant-details .description').each(function (x) {
    //x.down('.description-toggle').setStyle({'display':'none'}); // set in stylesheet
    var down = x.down('.variant-description-toggle');

    x.setStyle({
      'height': 'auto'
    });

    if (x.getHeight() > 54 && typeof down !== 'undefined') {
      x.setStyle({
        'height': '54px'
      });
      down.setStyle({
        'display': 'inline'
      });
    }
  });
};

CCShopify.toggleRepeatOrderHelptext = function () {
  $('repeat-order-helptext').toggle();
};

// disable unnecessary keystrokes in the input boxes
CCShopify.cleanKeyboardInputs = function (e) {
  var key = e.which || e.keyCode;
  if (!e.shiftKey && !e.altKey && !e.ctrlKey &&
    // numbers   
    key >= 48 && key <= 57 ||
    // Numeric keypad
    key >= 96 && key <= 105 ||
    // comma, period and minus, . on keypad
    key == 190 || key == 188 || key == 109 || key == 110 ||
    // Backspace and Tab and Enter
    key == 8 || key == 9 || key == 13 ||
    // Home and End
    key == 35 || key == 36 ||
    // left and right arrows
    key == 37 || key == 39 ||
    // Del and Ins
    key == 46 || key == 45)
    return true;
  return false;
};

/* Reorders an item from an Order page. */
CCShopify.reorderItem = function (item) {
  Shopify.addItem(item.variant_id, item.quantity);
};

/* If there are items in the queue, triggers the next AJAX query */
CCShopify.processQueue = function (queue) {
  if (queue.length > 0) {
    if (queue[0].quantity > 0) {
      Element.insert($('tinyboxshoppinglist'), {
        bottom: "<li><span>Adding </span>" + queue[0].quantity + " x " + queue[0].title + "</li>"
      });
      TINY.box.resize();
      Shopify.addItem(queue[0].variant_id, queue[0].quantity, this.queueResponseHandler.bind(this, queue));
    } else {
      Element.insert($('tinyboxshoppinglist'), {
        bottom: "<li class='not-added'>0 x " + queue[0].title + " - <em>item no longer stocked.</em>"
      });
      TINY.box.resize();
      queue.shift();
      CCShopify.processQueue(queue);
    }
  } else {
    $('message').update('Items added to your cart.').fade({
      delay: 1.5
    });
    Shopify.getCart();
    Element.insert($('tinyboxshoppinglist'), {
      after: "<p>The items above have been added to your cart.</p>"
    });
    $('tinyboxclosebutton').update('Close.');
  }
};

CCShopify.queueResponseHandler = function (queue, response) {
  // successfully added the last queue item.
  try {
    $$('#tinyboxshoppinglist li:last-child span')[0].remove();
  } catch (e) {}
  $$('#tinyboxshoppinglist li:last-child')[0].addClassName('added');
  queue.shift();
  CCShopify.processQueue(queue);
};

CCShopify.reorderPrevious = function (queue) {
  var p = function () {
    CCShopify.processQueue(queue.slice(0));
  };
  TINY.box.show({
    html: '<p>Please wait while we add this order to your cart.</p><ul id="tinyboxshoppinglist"></ul><p><a id="tinyboxclosebutton" onclick="TINY.box.hide();">Cancel</a></p>',
    close: false,
    openjs: p,
    fixed: false
  });
  //this.processQueue(queue.slice(0));
};
